<template>
    <div>
        <v-checkbox
                v-model="email"
                color="primary"
                required
        >
            <div slot="label">
                E-pošta - pošiljanje prilagojene ponudbe po elektronski pošti<br />
                (npr. obveščanje o stanju ugodnosti na vaši Tuš Cash & Carry klub kartici, vam prilagojene ponudbe izdelkov in popustov, ipd.)
            </div>
        </v-checkbox>
        <v-checkbox
                v-model="sms"
                color="primary"
                required
        >
            <div slot="label">
                SMS - pošiljanje prilagojene ponudbe po SMS-u<br />
                (npr. obveščanje o aktualno ponudbi, popustih, ipd.)
            </div>
        </v-checkbox>
    </div>
</template>

<script>
    import utils from "../store/utils";

    export default {
        name: "Consents",
        props: {
            vuex_module: {
                type: String,
                default: 'registration'
            },
            vuex_module_path_prefix: {
                type: String,
                default: null
            }
        },
        computed: {
            email: utils.vuexBuildSetGet(this, null, 'consent_channels.email', null, 'registration/refreshConsent'),
            sms: utils.vuexBuildSetGet(this, null, 'consent_channels.sms', null, 'registration/refreshConsent')
        }
    }
</script>

<style scoped>

</style>